var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "recent_container recent_block"
  }, [_vm._m(0), _c('div', {
    staticClass: "list"
  }, [_vm._m(1), _vm.blocks ? _c('div', [_vm.blocks.length > 0 ? [_c('ul', {
    staticClass: "list_container"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l(_vm.blocks, function (block) {
    return _c('li', {
      key: block.blockNumber,
      staticClass: "recent_row list_item bottom_border",
      attrs: {
        "id": "recent_block"
      }
    }, [_c('div', [_c('router-link', {
      staticClass: "id",
      attrs: {
        "to": _vm.hasSubnet ? {
          path: "/evmblock/".concat(block.blockNumber),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME,
            subnet: _vm.subnetName
          }
        } : {
          path: "/evmblock/".concat(block.blockNumber),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME
          }
        }
      }
    }, [_vm._v(_vm._s(block.blockNumber))]), _c('p', {
      staticClass: "time"
    }, [_vm._v(" " + _vm._s(_vm._f("fromNow")(parseInt(block.header.timestamp))) + " ")])], 1), _c('div', {
      staticClass: "totalTx"
    }, [_c('div', {
      staticClass: "count"
    }, [_vm._v(" " + _vm._s(block.transactions.length) + " ")])]), _c('div', {
      staticClass: "hash"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.hasSubnet ? {
          path: "/evmblock/".concat(block.header.hash),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME,
            subnet: _vm.subnetName
          }
        } : {
          path: "/evmblock/".concat(block.header.hash),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME
          }
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.shortenText(block.header.hash, 4, 4)) + " ")]), _c('CopyText', {
      attrs: {
        "value": block.header.hash
      }
    })], 1), _c('div', {
      staticClass: "fee"
    }, [_vm._v(" " + _vm._s(_vm._f("toDCM")(parseInt(block.header.gasUsed))) + " ")])]);
  }), 0)], 1)] : [_c('Loader', {
    attrs: {
      "message": "Fetching latest Blocks",
      "content-id": ""
    }
  })]], 2) : _c('p', [_vm._v("No Blocks found")]), _c('div', {
    staticClass: "view_all"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.hasSubnet ? {
        path: "/evmblock",
        query: {
          network: _vm.DEFAULT_NETWORK_NAME,
          subnet: _vm.subnetName
        }
      } : {
        path: "/evmblock",
        query: {
          network: _vm.DEFAULT_NETWORK_NAME
        }
      }
    }
  }, [_c('button', {}, [_vm._v(" See All Blocks "), _c('fa', {
    attrs: {
      "icon": "arrow-right"
    }
  })], 1)])], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header bottom_border"
  }, [_c('h1', [_vm._v("Latest Blocks")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "list_header list_item bottom_border",
    attrs: {
      "id": "recent_block"
    }
  }, [_c('h5', [_vm._v("Block Height")]), _c('h5', [_vm._v("Tx Count")]), _c('h5', [_vm._v("Block Hash")]), _c('h5', [_vm._v("Burnt Fee")])]);
}]

export { render, staticRenderFns }